export function formatPhoneNumber(phoneNumberString: string) {
    const phoneNumberWithoutHyphen = phoneNumberString.replace(/\D/g, '');
    return phoneNumberWithoutHyphen;
}
